import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import { SessionStorageService } from 'ngx-webstorage';
import { BaseService } from './base.service';
import * as moment from 'moment';
import { SettingsService } from 'src/app/modules/settings/settings.service';
//import { PrincipalService } from './principal.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService extends BaseService {
  /*********************Properties*********************/

  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(protected http: HttpClient, private cache: CacheResolverService,
    private storage: SessionStorageService,
    private settingService:SettingsService) {
    super(http);
  }

  get(shipTo = null,removeCache) {
    if(this.cache.get(CacheConstant.LocalStorage.route)){
      this.cache.remove(CacheConstant.LocalStorage.route);
    }
    if(this.cache.get(CacheConstant.LocalStorage.site)){
      this.cache.remove(CacheConstant.LocalStorage.site);
    }
    if(removeCache && this.cache.get(CacheConstant.LocalStorage.DeliveryAddress)){
      this.cache.remove(CacheConstant.LocalStorage.DeliveryAddress);
    }
    if(removeCache && this.cache.get(CacheConstant.LocalStorage.Mobile)){
      this.cache.remove(CacheConstant.LocalStorage.Mobile);
    }
    let requestedUrl = '';
    const url = this.apiConfig.util+'/api/user/account';
    let requestedShipTo = shipTo ? shipTo : this.storage.retrieve(CacheConstant.SessionStorageData.ShipTo);
    if (requestedShipTo) {
      requestedUrl = url + "?shipTo=" + requestedShipTo;
    } else {
      requestedUrl = url;
    }
    return super.fetch(requestedUrl).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
          this.storage.store(CacheConstant.SessionStorageData.AuthenticationToken, 'Bearer ' + response.data.access_token);
          this.storage.store(CacheConstant.SessionStorageData.ShipTo, response.data.defaultShipTo.id);
          this.storage.store(CacheConstant.SessionStorageData.NuctracAppMaintenance, response.data.nuctracAppMaintenance);
          this.storage.store(CacheConstant.SessionStorageData.NuctracAppPreferences, response.data.nuctracAppPreferences);
          this.storage.store(CacheConstant.SessionStorageData.LicenceData, response.data.licenseData.modules);
          this.storage.store(CacheConstant.SessionStorageData.LoggedInUser, response.data.lastName + ', ' + response.data.firstName);
          this.storage.store(CacheConstant.SessionStorageData.LoggedInUserID, response.data.id);
          this.storage.store(CacheConstant.SessionStorageData.Permissions,response.data.permissions);
          let ssoPreference: any = {};
          if (response.data && response.data.nuctracAppPreferences) {
            ssoPreference = (response.data.nuctracAppPreferences.filter(account => {
              return account.preferenceKey.indexOf("SSO_USER_ACCOUNT_VALIDATION") !== -1;
            }))[0];
          }
          let nuctracRejectNotificationCallTiming = {}
            if (response.data.nuctracAppPreferences) {
              nuctracRejectNotificationCallTiming = (response.data.nuctracAppPreferences.filter((time)=>{
              return time.preferenceKey.indexOf("NUCTRAC_DELAY_REJECT_NOTIFICATION_API") !== -1;
            }))[0];
          }
          this.storage.store(CacheConstant.SessionStorageData.nuctracRejectNotificationTiming,nuctracRejectNotificationCallTiming)
          this.storage.store(CacheConstant.SessionStorageData.SsoValidationFlag, ssoPreference && ssoPreference.preferenceValue && ssoPreference.preferenceValue.toUpperCase().indexOf('Y') !== -1);
          this.storage.store(CacheConstant.SessionStorageData.UserSsoFlag, response.data.userSsoFlag);
          this.storage.store(CacheConstant.SessionStorageData.AllDigiRadDepartments, response.data.departments);
          this.storage.store(CacheConstant.SessionStorageData.Email,response.data.emailId);
          this.storage.store(CacheConstant.SessionStorageData.EnablePoFlag,response.data.enablePOFlag);
          response.data.departments.forEach(department => {
            if (department.shipTo == response.data.defaultShipTo.id) {
              this.storage.store(CacheConstant.SessionStorageData.CustomerSsoFlag, department.customerSsoFlag);
              this.storage.store(CacheConstant.SessionStorageData.IsAccountHuborFacility, department);
              this.storage.store(CacheConstant.SessionStorageData.LocationNumber, department.locationNumber);
              this.storage.store(CacheConstant.SessionStorageData.TimeZoneText, department.TimeZoneText);
            }
          });
        }else{
         // window.location.href = 'https://npslogin2-dev.apps.cf.np.gc.cahcloud.net/login';
        //  this.principal.getEnvironment('logouturl').subscribe((response:IResponse)=>{
        //   let url=response.data.value;
        //    window.location.href =  url;
        // });
        }
        return response;
      })
    );
  }
  getUserDetails(data){
    if(data && data.id){
      return new Promise((resolve, reject) => {
        this.settingService.geteachuserConfig(data.id).subscribe((response: IResponse) => {
          let prmsList=[];
          if(response.data.userPermissions && response.data.userPermissions.length>0){

            response.data.userPermissions.forEach(element => {
              prmsList.push(element.id);

            });
          }
          this.storage.store(CacheConstant.SessionStorageData.Permissions,prmsList);
          // else{
          //   this.storage.store(CacheConstant.SessionStorageData.Permissions,response.data.permissions);
          // }
          resolve(true)
        });

      });
    }

  }

  getEnvironment(url){
    return super.fetch(this.apiConfig.util +'/api/environment'+'?type='+url);
  }

  updateDefaultAccount(userDetail) {
    const url = this.apiConfig.util+'/api/user/' + userDetail.id + '/updateDefaultAccount';
    return super.put(url, userDetail);
  }

  getMobiles(date) {
    const url =this.apiConfig.hp+ '/api/instrument/search';
    return super.fetch(url,{params:{type:10,date:moment(date).format(),searchAcrossDepts:true}}).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
        }
        return response;
      })
    );
  }

  getTruckShipTo(){
    const url = this.apiConfig.util + '/config/truckshipto';

    return super.fetch(url).pipe(
      map((response: IResponse) => {
        if (!response.hasError) {
        }
        return response;
      })
    );
  }
  
  userAccountChange(userDetail) {

    const url = this.apiConfig.util+'/api/user/accountChange';
  //  return super.post(url, userDetail,{observe: 'response'});

    return super.post(url, userDetail,
      {

        observe: 'response'
      }
    ).pipe(
      map((response: any) => {
        if (!response.hasError && response.data) {
          return response.data;
        } else {
          return null;
        }
      })
    );


  }

  getTimeZone() {
    return this.storage.retrieve(CacheConstant.SessionStorageData.TimeZoneText);
  }

}
